import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import './ReadOnlyLinkWithEditLink.scss';
var ReadOnlyInputWithEditLink = /*#__PURE__*/function (_Component) {
  function ReadOnlyInputWithEditLink(props) {
    var _this;
    _classCallCheck(this, ReadOnlyInputWithEditLink);
    _this = _callSuper(this, ReadOnlyInputWithEditLink, [props]);
    _this.state = {
      isEditing: false,
      value: props.value
    };
    _this.cancelEditing = _this.cancelEditing.bind(_this);
    _this.startEditing = _this.startEditing.bind(_this);
    _this.updateInputField = _this.updateInputField.bind(_this);
    return _this;
  }
  _inherits(ReadOnlyInputWithEditLink, _Component);
  return _createClass(ReadOnlyInputWithEditLink, [{
    key: "cancelEditing",
    value: function cancelEditing(event) {
      event.preventDefault();
      this.setState({
        isEditing: false,
        value: this.props.value
      });
    }
  }, {
    key: "startEditing",
    value: function startEditing(event) {
      event.preventDefault();
      this.setState({
        isEditing: true
      });
    }
  }, {
    key: "updateInputField",
    value: function updateInputField(event) {
      this.setState({
        value: event.target.value
      });
    }
  }, {
    key: "render",
    value: function render() {
      var input = null;
      var link = null;
      if (this.state.isEditing) {
        input = /*#__PURE__*/React.createElement("input", {
          type: this.props.inputType,
          value: this.state.value,
          onChange: this.updateInputField,
          name: this.props.name,
          className: "form-control"
        });
        link = /*#__PURE__*/React.createElement("a", {
          href: "# ",
          className: "btn",
          onClick: this.cancelEditing
        }, "Cancel");
      } else {
        var props = {
          type: this.props.inputType,
          name: this.props.name,
          value: this.props.value,
          className: 'disabled form-control'
        };
        if (this.props.disabled) {
          props.disabled = 'disabled';
        } else {
          props.readOnly = 'readonly';
        }
        input = /*#__PURE__*/React.createElement("input", props);
        link = /*#__PURE__*/React.createElement("a", {
          href: "# ",
          className: "btn",
          onClick: this.startEditing
        }, "Edit");
      }
      return /*#__PURE__*/React.createElement(Row, {
        className: "readonly-input-with-edit-link"
      }, /*#__PURE__*/React.createElement(Col, {
        xs: 8
      }, input), /*#__PURE__*/React.createElement(Col, {
        xs: 1
      }, link));
    }
  }]);
}(Component);
ReadOnlyInputWithEditLink.propTypes = {
  value: PropTypes.string,
  name: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  inputType: PropTypes.string
};
ReadOnlyInputWithEditLink.defaultProps = {
  value: '',
  disabled: false,
  inputType: 'text'
};
export default ReadOnlyInputWithEditLink;